import { z } from 'zod';

// Schema for the rate data object
const rateSchema = z.object({
    rate: z.string(),
    closed_to_arrival: z.number(),
    closed_to_departure: z.number(),
    max_stay: z.number(),
    min_stay_arrival: z.number(),
    min_stay_through: z.number(),
    stop_sell: z.number(),
});

// Schema for date-based data (dynamic keys for dates)
const dateDataSchema = z.record(rateSchema);

// Schema for UUID-based data (dynamic keys for UUIDs)
const dataSchema = z.record(dateDataSchema);

// Final schema for the entire response
const RestrictionRateSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: dataSchema,
});

export { RestrictionRateSchema };
export type RestrictionDataResponse = z.infer<typeof dataSchema>;
export type RestrictionRateResponse = z.infer<typeof RestrictionRateSchema>;